import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { personalInfo } from '../data/portfolio';

const roles = personalInfo.roles;

const TypewriterText = () => {
  const [currentRole, setCurrentRole] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const current = roles[currentRole];
    const speed = isDeleting ? 200 : 150;

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        if (displayText.length < current.length) {
          setDisplayText(current.slice(0, displayText.length + 1));
        } else {
          setTimeout(() => setIsDeleting(true), 1800);
        }
      } else {
        if (displayText.length > 0) {
          setDisplayText(current.slice(0, displayText.length - 1));
        } else {
          setIsDeleting(false);
          setCurrentRole((prev) => (prev + 1) % roles.length);
        }
      }
    }, speed);

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, currentRole]);

  return (
    <span className="gradient-text font-heading font-semibold">
      {displayText}
      <span
        className="inline-block w-0.5 h-8 md:h-10 lg:h-12 ml-1 align-middle"
        style={{
          backgroundColor: 'hsl(var(--primary))',
          animation: 'blink 1s step-end infinite'
        }}
      />
    </span>
  );
};

export default TypewriterText;
